import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { sectionWords } from '../../../actions/section';
import WordsChoose from './WordsChoose';
import WordChoose from './WordChoose';
import WordWatch from './WordWatch';
import WordTrack from './WordTrack';
import { shadowSize } from '../../../utils/utils';

export class Words extends React.Component {
	componentDidMount() {
		this.props.sectionWords();
		shadowSize();
	}
	render() {
        return (
			<div id="words" className="section">
			    <WordsChoose />
			    <WordChoose />
			    <WordWatch />
			    <WordTrack />
			</div>
		);
    }
};

const mapDispatchToProps = (dispatch) => ({
	sectionWords: () => dispatch(sectionWords())
});

export default connect(undefined, mapDispatchToProps)(Words);



// WEBPACK FOOTER //
// ./src/components/sections/words/Words.js